import { Ruleset } from 'enums/Ruleset';
import { ILineupEntry } from 'interfaces/team/ILineupEntry';
import { RulesetConfig } from 'models/ruleset/RulesetConfig';

export default class RulesetService {
  private getConfigObject = (ruleset: Ruleset): RulesetConfig | undefined => {
    switch (ruleset) {
      case Ruleset.americanLeague:
        return {
          maxPlayers: {
            min: 10,
            max: this.getPlayerLimitForAmericanLeague(),
          },
          validateLineup: (lineup: ILineupEntry[]): boolean => {
            return true;
          },
        };
      case Ruleset.scrimmage:
        return {
          maxPlayers: {
            min: 10,
            max: 10,
          },
          validateLineup: (lineup: ILineupEntry[]): boolean => {
            return true;
          },
        };
      default:
        return undefined;
    }
  };

  getPlayerLimit = (ruleset: Ruleset): number => {
    switch (ruleset) {
      case Ruleset.americanLeague:
        return this.getPlayerLimitForAmericanLeague();
      case Ruleset.scrimmage:
        return 16;
      case Ruleset.battingPractice:
      case Ruleset.nationalLeague:
        return 9;
      default:
        return 10;
    }
  };

  getPlayerLimitForAmericanLeague = (): number => {
    return process.env.REACT_APP_PLAYER_LIMIT_AMERICAN_LEAGUE ? Number(process.env.REACT_APP_PLAYER_LIMIT_AMERICAN_LEAGUE) : 10;
  };
}
